// extracted by mini-css-extract-plugin
export default {"breadcrumbsList":"Breadcrumbs_breadcrumbsList__-h03b typography_fontStyleBody__-8KSo"};